import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@teamhive/lottie-player/loader';
import{ Amplify, Auth } from "aws-amplify";
import aws_exports from "./aws-exports";
Auth.configure({ storage: sessionStorage });
Amplify.configure(aws_exports);
defineCustomElements(window);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
